var data = {
  login: {
    idSave: 'N',
    userId: ''
  },
  child: {
    name: '',
    data: {}
  },
  parent: {
    name: '',
    data: {}
  },
  prensrnoinfo: {
    name: '',
    data: {}
  },
  appdb: {
    key: '',
    value: ''
  },
  duplicate: {
    atnd: true,
    dateString: '19880101010101',
    time: 0
  }
};

var mutations = {
  'SET_UI_LOGIN'(state, login) {
    state.login.idSave = login.idSave;
    state.login.userId = login.userId;
  },
  'SET_UI_CHILD'(state, child) {
    state.child = child;
  },
  'SET_UI_PARENT'(state, parent) {
    state.parent = parent;
  },
  'SET_UI_PRENSRNOINFO'(state, prensrnoinfo) {
    state.prensrnoinfo = prensrnoinfo;
  },
  'SET_UI_APPDB'(state, appdb) {
    state.appdb = appdb;
  },
  'SET_UI_DUPLICATE'(state, duplicate) {
    state.duplicate = duplicate;
  },
};

var actions = {
};

var getters = {
  ui: state => state,
  child: state => state.child,
  parent: state => state.parent,
  prensrnoinfo: state => state.prensrnoinfo,
  appdb: state => state.appdb,
  duplicate: state => state.duplicate
};

export default {
  state:data,
  getters,
  actions,
  mutations
}
